
import Vue from 'vue'
import * as rules from 'vee-validate/dist/rules'
import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'

localize({
  en: {
    messages: {
      required: field => {
        return `The ${field} field is required`
      },

      required_if: field => {
        return `The ${field} field is required`
      },

      email: field => {
        return `The ${field} must be a valid email address`
      },

      double: field => {
        return `The ${field} must be a valid number`
      },

      max: (field, option) => {
        return `The ${field} must be atleast lesser than or equal to ${option.length} characters`
      },

      min: (field, option) => {
        return `The ${field} must be atleast greater than or equal to ${option.length} characters`
      },

      max_value: (field, option) => {
        return `The ${field} must be atleast lesser than or equal to ${option.max}`
      },

      min_value: (field, option) => {
        return `The ${field} must be atleast greater than or equal to ${option.min}`
      },

      confirmed: (field, option) => {
        return `The ${field} must be the same as the value of ${option.target}`
      }
    }
  }
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('currency', {
  validate (value, { min }) {
    const transformToNumericValue = parseFloat(value.length ? value.replace(/,/g, '') : value)
    return !isNaN(transformToNumericValue) && transformToNumericValue >= min
  },
  params: ['min'],
  message: 'Please enter a valid currency amount and must be greater than {min}.'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
